import BackendService from './BackendService';

/**
 * AdvisorBackendService should not be used in the admin app.
 * This class exists only for TypeScript compilation purposes.
 * It extends BackendService to match all method signatures, but throws an error if constructed.
 */
export default class AdvisorBackendService extends BackendService {
  constructor() {
    super();
    throw new Error(
      'AdvisorBackendService should not be used in the admin app. Use BackendService instead.',
    );
  }
}
